import { Outlet, RouteObject } from 'react-router-dom'
import { permissionAssignmentRoute } from './route.constant'
import PermissionAssignmentList from '../pages/permission-assignment/PermissionAssignmentList.page'
import { AssignPermissions } from '../pages/permission-assignment/AssignPermissions'
import { SupervisorProtectedRoute } from '../guards/supervisor.guard'
import { ReadOnlyProtectedRoute } from '../guards/readonly.guard'
import { AdminProtectedRoute } from '../guards/admin.guard'
import { CurrentUserProtectedRoute } from '../guards/currentuser.guard'

export const permissionAssignmentRoutes: RouteObject = {
  path: `${permissionAssignmentRoute}`,
  element: (
    <SupervisorProtectedRoute>
      <ReadOnlyProtectedRoute>
        <CurrentUserProtectedRoute>
          <Outlet />
        </CurrentUserProtectedRoute>
      </ReadOnlyProtectedRoute>
    </SupervisorProtectedRoute>
  ),
  handle: { crumb: () => 'Permission Assignment' },
  children: [
    {
      path: '',
      element: <PermissionAssignmentList defaultTab="Program Permissions" />,
    },
    {
      path: 'global',
      element: (
        <AdminProtectedRoute>
          <PermissionAssignmentList defaultTab="Global Permissions" />
        </AdminProtectedRoute>
      ),
    },
    {
      path: 'assign-permissions',
      element: <AssignPermissions actionMode="create" isGlobalSet={false} />,
      handle: { crumb: () => 'Assign Permission Sets' },
    },
    {
      path: 'assign-permissions/global',
      element: (
        <AdminProtectedRoute>
          <AssignPermissions actionMode="create" isGlobalSet={true} />
        </AdminProtectedRoute>
      ),
      handle: { crumb: () => 'Assign Permission Sets' },
    },
    {
      path: 'view',
      children: [
        {
          path: ':userId',
          element: <AssignPermissions actionMode="view" isGlobalSet={false} />,
          handle: {
            crumb: () => 'View Assigned Permissions',
          },
        },
      ],
    },
    {
      path: 'edit',
      children: [
        {
          path: ':userId',
          element: <AssignPermissions actionMode="edit" isGlobalSet={false} />,
          handle: { crumb: () => 'Assign Permission Sets' },
        },
      ],
    },
    {
      path: 'clone',
      children: [
        {
          path: ':userId',
          element: <AssignPermissions actionMode="clone" isGlobalSet={false} />,
          handle: { crumb: () => 'Assign Permission Sets' },
        },
      ],
    },
    {
      path: 'global/view',
      children: [
        {
          path: ':userId',
          element: (
            <AdminProtectedRoute>
              <AssignPermissions actionMode="view" isGlobalSet={true} />
            </AdminProtectedRoute>
          ),
          handle: {
            crumb: () => 'View Assigned Permissions',
          },
        },
      ],
    },
    {
      path: 'global/edit',
      children: [
        {
          path: ':userId',
          element: (
            <AdminProtectedRoute>
              <AssignPermissions actionMode="edit" isGlobalSet={true} />
            </AdminProtectedRoute>
          ),
          handle: { crumb: () => 'Assign Permission Sets' },
        },
      ],
    },
    {
      path: 'global/clone',
      children: [
        {
          path: ':userId',
          element: (
            <AdminProtectedRoute>
              <AssignPermissions actionMode="clone" isGlobalSet={true} />
            </AdminProtectedRoute>
          ),
          handle: { crumb: () => 'Assign Permission Sets' },
        },
      ],
    },
  ],
}
